module.exports = __webpack_public_path__ + "img/bild-h.ab27b2c3.png";